import { useFormContext } from 'react-hook-form';

import type { EditPermissionsFormProps } from './types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useEditPermissionsFormContext = () => useFormContext<EditPermissionsFormProps>();
